module.exports = __webpack_public_path__ + "static/media/Merfolk-Unselected.1f4b5c42.png";